
export class Article {
  // id: number;
  // GUID: string;
  slug: string;
  // codeEAN: string;
  // libelle = '';
  // description = '';
  // body = '';
  // tagList: Array<string> = [];
  // createdAt: string;
  // updatedAt: string;
  favorited: boolean;
  favoritesCount: number;
  article: Array<string> = [];
  articleConnexe: Array<string> = [];
  typeArticle: Array<string> = [];
  niveauScolaire: Array<string> = [];
  discipline: Array<string> = [];
  publicCible: Array<string> = [];
  supportDistribution: Array<string> = [];
  editeur: Array<string> = [];
  plateformeSupportee: Array<string> = [];
  technologieSupport: Array<string> = [];
  offreCommerciale: Array<string> = [];
  tauxTaxe: Array<string> = [];

}



// WEBPACK FOOTER //
// ./src/app/shared/models/article.model.ts